import { Modal } from "antd";
import { FormProcedimento } from "../../../../types/state.types";
import { ProcedimentoListagem } from "../../../../types/Procedimentos.types";
import InputLabel, {
  InputLabelSelect,
} from "../../../../components/inputLabel";
import { useEffect, useMemo } from "react";
import { formatMoney } from "../../../../utils/functions-helper";

type ModalProps = {
  open: boolean;
  form: FormProcedimento;
  changeForm: (change: Record<string, any>) => void;
  competencia: string;
  contrato?: string;
  listaContratos: { Nome: string; ID: number }[];
  buscarProcedimentos: (parm: any) => void;
  listaProcedimentos: ProcedimentoListagem[];
  setFiltros: (value: { contrato?: string; competencia?: string }) => void;
  onOk: () => void;
  onCancel: () => void;
};

const ModalNovoProcedimento = ({
  open,
  form,
  changeForm,
  competencia,
  contrato,
  listaContratos,
  buscarProcedimentos,
  listaProcedimentos,
  setFiltros,
  onOk,
  onCancel,
}: ModalProps) => {
  const contratoSelecionado = useMemo(
    () => contrato !== undefined && contrato !== "0",
    [contrato]
  );
  const formValido = useMemo(() => {
    return (
      contrato !== undefined &&
      contrato !== "0" &&
      competencia.length === 7 &&
      form.ID_ProcedimentoContrato !== 0 &&
      form.Prontuario.length > 0 &&
      form.Paciente.length > 1 &&
      form.Data.length === 10 &&
      form.Quantidade.length > 0 &&
      Number(form.Quantidade) > 0 &&
      form.Valor.length > 0
    );
  }, [competencia, contrato, form]);

  useEffect(() => {
    if (contrato) buscarProcedimentos(contrato);
  }, [buscarProcedimentos, contrato]);

  return (
    <Modal
      title="Incluir Procedimento"
      open={open}
      onOk={onOk}
      okText={form.ID ? "Salvar" : "Incluir"}
      cancelText="Cancelar"
      okButtonProps={{
        disabled: !formValido,
      }}
      onCancel={onCancel}
      onClose={onCancel}
    >
      <InputLabelSelect
        labelText="Contrato"
        labelId="contrato"
        column
        options={listaContratos.map((item) => {
          return {
            label: item.ID === 0 ? "Selecionar" : item.Nome,
            value: item.ID,
          };
        })}
        value={contrato}
        onChange={(value) => setFiltros({ contrato: value })}
        required
      />
      <InputLabel
        labelText="Competência"
        labelId="competencia"
        value={competencia}
        mask="99/9999"
        disabled
        column
      />

      <InputLabel
        labelText="Prontuário"
        labelId="prontuario"
        value={form.Prontuario}
        onChange={(value) => changeForm({ Prontuario: value })}
        disabled={!contratoSelecionado}
        tooltipText={contratoSelecionado ? undefined : "Selecione um Contrato"}
        column
      />

      <InputLabel
        labelText="Nome do paciente"
        labelId="paciente"
        value={form.Paciente}
        onChange={(value) => changeForm({ Paciente: value })}
        disabled={!contratoSelecionado}
        tooltipText={contratoSelecionado ? undefined : "Selecione um Contrato"}
        column
      />

      <InputLabel
        labelText="Data de realização"
        labelId="data"
        value={form.Data}
        onChange={(value) => changeForm({ Data: value })}
        disabled={!contratoSelecionado}
        tooltipText={contratoSelecionado ? undefined : "Selecione um Contrato"}
        mask="99/99/9999"
        column
      />

      <InputLabelSelect
        labelText="Procedimento"
        labelId="procedimento"
        column
        options={listaProcedimentos.map((item) => {
          return { label: item.Procedimento.Nome, value: item.ID };
        })}
        value={form.ID_ProcedimentoContrato.toString()}
        onChange={(value) => {
          const valor = listaProcedimentos.find(
            (procedimento) => procedimento.ID === Number(value)
          );

          if (valor)
            changeForm({
              ID_ProcedimentoContrato: value,
              Valor: formatMoney(valor.Valor),
              Quantidade: "1",
            });
        }}
        disabled={!contratoSelecionado}
        tooltipText={contratoSelecionado ? undefined : "Selecione um Contrato"}
        required
      />

      <InputLabel
        labelText="Quantidade"
        labelId="quantidade"
        value={form.Quantidade}
        onChange={(value) => changeForm({ Quantidade: value })}
        disabled={!contratoSelecionado}
        tooltipText={contratoSelecionado ? undefined : "Selecione um Contrato"}
        mask="9999"
        column
      />

      <InputLabel
        labelText="Valor"
        labelId="valor"
        value={form.Valor}
        onChange={(value) => changeForm({ Valor: value })}
        disabled={!contratoSelecionado}
        tooltipText={contratoSelecionado ? undefined : "Selecione um Contrato"}
        column
      />
    </Modal>
  );
};

export default ModalNovoProcedimento;
